import { Avatar, Button, Card, Center, Stack, Text } from "components";
import { useSocket, useStateValue } from "providers";
import { useEffect, useState } from "react";

export const PendingTriviaGame = ({ queue, reFetch, startGame }) => {
  const socket = useSocket();
  const [playerCount, setPlayerCount] = useState(queue?.players?.length);

  useEffect(() => {
    if (!queue?.slug) return;
    const channel = `/trivia/${queue.slug}`;
    const handleSocketEvent = () => {
      reFetch(true);
    };
    socket.on(channel, handleSocketEvent);
    return () => socket.off(channel, handleSocketEvent);
  }, [socket, queue?.slug, reFetch]);

  useEffect(() => {
    setPlayerCount(queue?.players?.length);
  }, [queue]);

  return (
    <Card>
      {playerCount ? (
        <Stack horizontal={true} margin="1rem 0.5rem">
          {queue?.players?.map((player) => (
            <Avatar key={player.id}>{player.email}</Avatar>
          ))}
        </Stack>
      ) : (
        <Center>
          <Text>Waiting for players to join...</Text>
        </Center>
      )}
      <Button onPress={startGame}>Start</Button>
    </Card>
  );
};
